import * as jsxRuntime from "E:\\xampp\\htdocs\\hexcoupon\\wp-content\\plugins\\hex-coupon-for-woocommerce\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment